import CallIcon from '@mui/icons-material/Call';
import PersonIcon from '@mui/icons-material/Person';
import Avatar from '@mui/material/Avatar';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
import { stringAvatar } from 'utils';
import { formatPhoneNumber } from 'utils';

const CallerID = ({ from, name }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        bgcolor: 'background.default',
        mb: 2,
        mt: 4,
        p: 1,
        borderRadius: 1,
      }}
    >
      <Stack alignItems="center">
        <Avatar
          {...stringAvatar(from, {
            width: 60,
            height: 60,
            mb: 1,
            mt: -4,
            border: '2px solid #eee',
          })}
        >
          <PersonIcon />
        </Avatar>
        {name && (
          <Typography gutterBottom fontWeight={500}>
            {name}
          </Typography>
        )}
        <Stack direction="row" alignItems="center" spacing={1}>
          <CallIcon fontSize="inherit" />
          <Typography variant="body2" color="text.secondary">
            {formatPhoneNumber(from)}
          </Typography>
        </Stack>
      </Stack>
    </Paper>
  );
};

export default CallerID;
